var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bottom-nav-bar"},_vm._l((_vm.options),function(item){return _c('div',{key:item.key,staticClass:"bottom-nav-bar-item",on:{"click":() => _vm.handleNavBarClick(item)}},[_c('img',{staticClass:"bottom-nav-bar-icon",attrs:{"src":_vm.curNav === item.key ? item.selectedIcon : item.defaultIcon}}),_c('div',{staticClass:"bottom-nav-bar-text",class:{
          active: _vm.curNav === item.key,
        }},[_vm._v(" "+_vm._s(item.text)+" ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }